// Module
var code = `<div class="charge">
  <div>
    <span>
      Initial payment:
    </span>
    <cash ng-model="\$ctrl.charge.initialPayment"
      ng-required="true"></cash>
  </div>
  <div>
    <span>
      Step:
    </span>
    <cash ng-model="\$ctrl.charge.stepValue"
      ng-required="true"></cash>
  </div>
  <div>
    <span>
      Charge for each step:
    </span>
    <cash ng-model="\$ctrl.charge.chargeForEachStep"
      ng-required="true"></cash>
  </div>
  <div>
    <span>
      Do charge for first step:
    </span>
    <input type="checkbox"
           ng-model="\$ctrl.charge.doChargeFirstStep"/>
  </div>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/charge/progressive-charge.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;